import React, { useContext, useRef, useEffect, useMemo, useState, useCallback } from 'react';
import Slider from 'react-slick';

import * as S from './TestimonialStyles';
import DisplayContext from 'UtilityComponents/displayContext';
import { Heading, FlexDiv, SubTitle, GenericP } from 'commonStyles';
import { landingImgPath, TestimonialData } from '../../config';
import { ADOBE_EVENT_VALUES } from 'AppConstants';
import { loadNextComponent, trackClickEvents } from '../../utils';
import { getMyBizTestimony } from '../../landingApi';
import landingContext from '../../landingContext';
import Loader from 'common/Loader/Loader';
import { SliderArrowNext, SliderArrowPrev } from 'common/SliderArrows/SliderArrows';

const Testimonial = ({ showNextComp, nextComp, isCorpSeo }) => {
	const displayName = useContext(DisplayContext).isMobile;
	const { appSsrData = { bizTestimony: [] } } = useContext(landingContext) || {};

	const isMobile = displayName == 'mobile';

	const [testimonies, setTestimony] = useState((isCorpSeo ? TestimonialData : appSsrData?.bizTestimony) || []);

	const refHtml = useRef();

	const getDetails = useCallback(async () => {
		if (!appSsrData?.bizTestimony?.length) {
			const response = await getMyBizTestimony();
			setTestimony(response.bizTestimony);
		}
	}, [setTestimony]);

	useEffect(() => {
		loadNextComponent(refHtml, showNextComp, nextComp);
		getDetails();
	}, []);

	const windowWidth = typeof window === 'undefined' ? 0 : window.innerWidth;

	const settings = useMemo(() => ({
		arrows: true,
		swipeToSlide: true,
		speed: 500,
		slidesToShow: windowWidth > 1024 ? 3 : windowWidth > 767 ? 2 : 1,
		slidesToScroll: 1,
		infinite: false,
		nextArrow: <SliderArrowNext isMobile={isMobile} customClick={() => trackClickEvents(ADOBE_EVENT_VALUES.LANDING?.REVIEW_MOVE)} />,
		prevArrow: <SliderArrowPrev isMobile={isMobile} customClick={() => trackClickEvents(ADOBE_EVENT_VALUES.LANDING?.REVIEW_MOVE)} />,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1.5,
					slidesToScroll: 1
				}
			}
		]
	}), [isMobile]);

	return (
		<S.TestimonialContainer ref={refHtml}>

			{testimonies &&
			<>
				<Heading as='h3' font_size={`${isMobile ? '28' : '40'}`} marBt='50px'>
					Business Travellers Love Us{' '}
				</Heading>
				{!testimonies ? <Loader color='#723b63' /> :
				<S.SliderOuterWrap>
					<Slider {...settings}>
						{testimonies && !testimonies.error && testimonies.map((data, index) => {
							const { name, testimony, company, iconUrl = landingImgPath + 'ml.png' } = data;
							return (
								<S.TestimonialInnerWrap key={index}>
									<FlexDiv $width='52px' height='52px'>
										<img crossOrigin='anonymous' src={iconUrl} $width='52' height='52' alt='testimony-icon' loading='lazy' />
									</FlexDiv>
									<S.TestimonialTextWrap>{testimony}</S.TestimonialTextWrap>
									<SubTitle color='#3b385e' fSize={`${isMobile ? '18px' : '24px'}`}>
										{name}
									</SubTitle>
									<GenericP fsize='12px'>{company}</GenericP>

								</S.TestimonialInnerWrap>
							);
						})}
					</Slider>
				</S.SliderOuterWrap>}
			</>}
		</S.TestimonialContainer>
	);
};

export default Testimonial;
